import { T, useTranslate } from "@tolgee/react";

import { cn } from "#/lib/utils.ts";

import { LandingPrimaryCta } from "./landing-primary-cta.tsx";
import { RevealOnScroll, scaleIn } from "#/components/ui/motion-primitives";
import { sectionClass } from "./landing-styles";

export function FinalCtaSection() {
	const { t } = useTranslate();

	return (
		<section className={cn(sectionClass, "border-b-0")}>
			<div className="relative px-[18px] py-[54px] text-center md:px-[42px] md:py-[72px]">
				<RevealOnScroll
					className="mx-auto max-w-[860px] rounded-[32px] border border-[var(--color-theme-static-white)]/10 px-6 py-10 md:px-10 md:py-14"
					variants={scaleIn}
					duration={0.7}
				>
					<div className="mx-auto inline-flex items-center gap-2 rounded-full border border-primary/16 bg-primary/10 px-4 py-2 text-label2-bold text-primary">
						{t("cta.badge")}
					</div>
					<h2 className="mt-5 text-display2 text-foreground">
						<T
							keyName="cta.heading"
							params={{
								accent: <span className="text-primary" />,
								break: <br className="sm:hidden" />,
							}}
						/>
					</h2>
					<p className="mx-auto mt-4 max-w-[560px] text-headline-medium text-muted-foreground">
						{t("cta.description")}
					</p>

					<div className="mt-7">
						<LandingPrimaryCta label={t("cta.primary")} location="final_cta" />
					</div>
				</RevealOnScroll>
			</div>
		</section>
	);
}
